import React from "react";

import {
  Box,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { colors } from "../../../assets/styles/theme";

interface DeleteFileProps {
  open: any;
  handleCancel?: () => void;
  handleConfirm?: () => void;
  subject: any;
  isLoading: any;
  fileName: any;
  status: any;
}

const DeleteFile: React.FC<DeleteFileProps> = ({
  open,
  handleConfirm,
  handleCancel,
  subject,
  isLoading,
  fileName,
  status,
}) => {
    console.log("status", status);
    console.log("subject", subject);
    const StatusMessage = subject != 'Status' && (status != null ? (status ? 'Active' : 'In Active') : "")
    const fileStatus = subject == 'Status' && (status != null ? (status ? 'Sensitive' : 'Non-Sensitive') : "")
    const action = subject == 'Delete' ? `Delete ${fileName}` : `Change ${fileName} to`;  
    const message = `Are you sure you want to ${action} ${fileStatus || StatusMessage} ?`
    const deleteMessage = subject == 'Delete' ? `Are you sure you want to ${action} ?` : message;
    
  return (
    <>
      <Dialog
        onClose={(event, reason) => {
          if (reason === 'backdropClick') {
            return;
          }
        }}
        slotProps={{
          backdrop: {
            onClick: (e) => e.stopPropagation() 
          }
        }}
        aria-labelledby="download-attachment-modal"
        open={open}
        fullWidth={true}
        maxWidth={false}
        sx={{
          "& .MuiDialog-paper": {
            maxWidth: "440px",
          },
          "& .MuiDialogContent-root": {
            padding: 2,
          },
          "& .MuiDialogActions-root": {
            padding: 1,
          },
        }}
        className="digitalModal"
      >
        <DialogContent>
          <Box sx={{ p: "0 10px 0 10px", mt: 1 }}>
            <Typography variant="body1" component="span" className="fs-13">
              {" "}
              {deleteMessage} 
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions className="" sx={{ pt: "5px !important", boxShadow: 'none !important'}}>
          <Button
            onClick={handleCancel}
            variant="outlined"
            size="small"
            sx={{ mr: 1 }}
          >
            CANCEL
          </Button>
          <Button onClick={handleConfirm} variant="contained" size="small">
            CONFIRM  {isLoading &&  <CircularProgress size="1rem" sx={{color: colors.primaryDark, ml: 1 }} />}
          </Button>          
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteFile;
